// Step timer for the "agent reads the layers" animation on /layered.
// Every value in the markup is derived from this one counter, so the markup
// stays declarative and the timing lives in exactly one place.
const DELAYS = [1100, 1100, 1100, 1100, 1100, 1300, 2800, 1400]
const FINISHED_STEP = 6

export default function agentReadsLayers() {
  return {
    step: 0,
    timer: null,

    get s() {
      return this.step === 7 ? 0 : this.step
    },

    start() {
      this.stop()
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.step = FINISHED_STEP
        return
      }
      const go = (i) => {
        this.step = i
        this.timer = setTimeout(() => go((i + 1) % DELAYS.length), DELAYS[i])
      }
      go(0)
    },

    stop() {
      clearTimeout(this.timer)
    },

    ring(index) {
      const active = this.s === index
      const read = this.s > index
      return {
        stroke: active
          ? "var(--color-primary)"
          : read
            ? "color-mix(in srgb, var(--color-primary) 40%, transparent)"
            : "color-mix(in srgb, var(--color-brand-dark) 11%, transparent)",
        width: active ? 2.5 : 1.25,
        dash: active ? "none" : "4 8",
      }
    },

    get dotTop() {
      return [200, 158, 122, 86, 50, 14, 14][this.s]
    },
  }
}
